var _path, _circle, _circle2, _circle3, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBusProgress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 261,
    viewBox: "0 0 79 261",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46 20L46 252",
    stroke: "#FFF1BF",
    strokeWidth: 5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 109,
    r: 33,
    fill: "#FFE280"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 246,
    r: 15,
    fill: "#FFE280"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 15,
    r: 15,
    fill: "#FFE280"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66675 118.459C7.66675 111.75 14.5284 110.792 23.0001 110.792C31.4717 110.792 38.3334 111.75 38.3334 118.459V137.625C38.3334 139.312 37.5859 140.826 36.4167 141.88V145.292C36.4167 146.346 35.5542 147.209 34.5001 147.209H32.5834C31.5292 147.209 30.6667 146.346 30.6667 145.292V143.375H15.3334V145.292C15.3334 146.346 14.4709 147.209 13.4167 147.209H11.5001C10.4459 147.209 9.58341 146.346 9.58341 145.292V141.88C8.41425 140.826 7.66675 139.312 7.66675 137.625V118.459ZM23.0001 114.625C15.9276 114.625 13.2059 115.507 12.1517 116.523H33.8484C32.7942 115.507 30.0726 114.625 23.0001 114.625ZM34.5001 120.356V126.125H11.5001V120.356H34.5001ZM33.2926 139.542L33.8484 139.024C34.0976 138.814 34.5001 138.334 34.5001 137.625V129.959H11.5001V137.625C11.5001 138.334 11.9026 138.814 12.1517 139.024L12.7076 139.542H33.2926ZM16.2917 131.875C14.7039 131.875 13.4167 133.163 13.4167 134.75C13.4167 136.338 14.7039 137.625 16.2917 137.625C17.8796 137.625 19.1667 136.338 19.1667 134.75C19.1667 133.163 17.8796 131.875 16.2917 131.875ZM26.8334 134.75C26.8334 133.163 28.1206 131.875 29.7084 131.875C31.2962 131.875 32.5834 133.163 32.5834 134.75C32.5834 136.338 31.2962 137.625 29.7084 137.625C28.1206 137.625 26.8334 136.338 26.8334 134.75Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusProgress);
export default __webpack_public_path__ + "static/media/bus-progress.ebe7937ef854da5d5d314c637eba27f5.svg";
export { ForwardRef as ReactComponent };